class CustomSignUpForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form?.addEventListener('submit', this.handleSubmit.bind(this));
      this.submitButton = this.form?.querySelector('.sign-up-form__submit');
      this.errorMessage = this.getAttribute('data-error-message');
      this.successPage = this.getAttribute('data-success-page');
      this.alreadyLoyalPage = this.getAttribute('data-already-loyal-page');
      this.failedPage = this.getAttribute('data-failed-page');
    }
  
    /**
     * Handles the form submission.
     * @param {Event} event - The event that triggered the submission.
     */
    handleSubmit(event) {
      event.preventDefault();
      if (!this.form) return;
  
      // Get submit button and add loading state
      if (!this.submitButton || !(this.submitButton instanceof HTMLButtonElement)) return;
      
      this.submitButton.disabled = true;
      this.submitButton.classList.add('loading');
  
      const formData = new FormData(this.form);
      const body = {
        customer_id: formData.get('customer_id') || null,
        name: formData.get('name'),
        last_name: formData.get('lastname'),
        email: formData.get('email'),
        phone: formData.get('phone'),
        dob: formData.get('dob'),
        storename: formData.get('storename'),
        store_code: formData.get('store_code'),
        email_consent: formData.get('email_consent') === 'on',
        sms_consent: formData.get('sms_consent') === 'on',
      }
  
      this.submitEmail(body);
    }
  
    /**
     * Submits the email data to the server.
     * @param {Object} emailData - The form data to submit.
     */
    submitEmail(emailData) {
      fetch('/apps/datajet/task/689987afcb5df22d0cb3b26c', {
        method: "POST",
        body: JSON.stringify(emailData),
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => res.clone().json())
        .then((res) => {
          if (res.status === 'error') {
            if (this.failedPage) {
              window.location.href = this.failedPage
            }
          } else {
            if (res.type === "already_loyal" && this.alreadyLoyalPage) {
              window.location.href = this.alreadyLoyalPage 
            }
            if (res.type === "success" && this.successPage) {
              window.location.href = this.successPage
            }
          }
        })
        .catch((error) => {
          console.error('Form submission error:', error);
          if (this.failedPage) {
            window.location.href = this.failedPage
          }
        })
        .finally(() => {
          // Remove loading state from form button
          if (!this.submitButton || !(this.submitButton instanceof HTMLButtonElement)) return;
          this.submitButton.disabled = false;
          this.submitButton.classList.remove('loading');
        });
    }
  }
  
  customElements.define('custom-sign-up-form', CustomSignUpForm);